export default __webpack_public_path__ + "static/media/abid5.2afe9476.png";